import ScrollWrapper from "../../../Components/ScrollWrapper";
import Text from "../../../Components/Text";
import SmallImage from "../../../Components/SmallImage";
import ChapterToggler from "../../../Components/ChapterToggler";

const CreateCoupon = () => {
    return (
        <ScrollWrapper>
            <div className="w-full h-full flex flex-col p-3 gap-4">
                <Text type="maintitle">Coupons Verwalten</Text>

                <Text type="itemtext">
                    Mit Coupons kannst du spezielle Angebote an deine Kunden machen –
                    ein guter Weg, um neue Kunden zu gewinnen.
                </Text>

                <Text type="itemtext">
                    Jeder Coupon-Code ist einzigartig und kann nur einmalig verwendet werden.
                    Die Coupons können an der Kasse eingescannt werden.
                </Text>

                <SmallImage src={"instructions/coupon-main.png"} />

                {/* Übersicht */}
                <div className="w-full flex flex-col">
                    <Text type="title">1. Neue Coupons erstellen</Text>
                    <Text type="title">2. Coupons drucken</Text>
                    <Text type="title">3. Alle aktiven Coupons</Text>
                    <Text type="title">4. Löschen</Text>
                </div>

                {/* 1. Neue Coupons erstellen */}
                <ChapterToggler title="1. Neue Coupons erstellen">
                    <Text type="itemtext">
                        Durch das Drücken auf diesen Knopf öffnet sich folgendes Formular:
                    </Text>

                    <br />

                    <SmallImage
                        src={"instructions/coupon-create.png"}
                        smallSize="w-1/2"
                        subtitle="Coupon Formular"
                    />

                    <br />

                    <Text type="itemtext">
                        Folgende Eigenschaften können definiert werden:
                    </Text>

                    <Text type="itemtext">
                        <b>Anzahl Coupons:</b> Anzahl der zu erstellenden Coupons
                    </Text>
                    <Text type="itemtext">
                        <b>Gutschein-Preis:</b> Gesamtpreis aller enthaltenen Produkte
                    </Text>
                    <Text type="itemtext">
                        <b>+ Produkt:</b> Fügt ein weiteres Produktfeld hinzu
                        (standardmässig ist ein Produkt enthalten)
                    </Text>
                    <Text type="itemtext">
                        <b>Produkt:</b> Auswahl eines aktiven Produkts
                    </Text>
                    <Text type="itemtext">
                        <b>Anzahl:</b> Anzahl des gewählten Produkts im Coupon
                    </Text>
                </ChapterToggler>

                {/* 2. Coupons drucken */}
                <ChapterToggler title="2. Coupons drucken">
                    <Text type="itemtext">
                        Durch das Drücken auf diesen Knopf wird eine PDF-Datei
                        mit allen noch aktiven Coupons erstellt.
                    </Text>

                    <br />

                    <SmallImage
                        src={"instructions/coupons-print.png"}
                        subtitle="Beispiel PDF-Bogen mit Coupons"
                    />
                </ChapterToggler>

                {/* 3. Alle aktiven Coupons */}
                <ChapterToggler title="3. Alle aktiven Coupons">
                    <Text type="itemtext">
                        Hier werden alle aktuell noch gültigen Coupons angezeigt.
                    </Text>
                </ChapterToggler>

                {/* 4. Löschen */}
                <ChapterToggler title="4. Löschen">
                    <Text type="itemtext">
                        Über diesen Knopf können Coupons gelöscht werden.
                        Gelöschte Coupons sind danach nicht mehr gültig.
                    </Text>
                </ChapterToggler>
            </div>
        </ScrollWrapper>
    );
};

export default CreateCoupon;
